import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('DashboardUI', {
  library: 'dashboard-ui-components'
});